<div class="masonry" style={masonryStyle}>

    <slot />

</div>

<style>
    .masonry {
        display: grid;
    }
</style>

<script>
    export default {
        computed: {
            masonryStyle: ({ layout, rows, columns }) => {
                let styles = []
                let areas = layout.split('|').join('" "')

                styles.push(`grid-template-areas: "${areas}";`)

                if (rows) styles.push(`grid-template-rows: ${rows};`)

                if (columns) styles.push(`grid-template-columns: ${columns};`)

                return styles.filter(Boolean).join('');
            }
        },
        data() {
            return {
                layout: '',
                rows: null,
                columns: null,
            }
        }
    }
</script>